import { createContext, useContext, useMemo, useState } from 'react';
import useCrmObjectTypeListingFilterState from 'framework-listing-lib/internal/hooks/useCrmObjectTypeListingFilterState';
import { jsx as _jsx } from "react/jsx-runtime";
const CrmObjectTypeListingContext = /*#__PURE__*/createContext(undefined);
export default function CrmObjectTypeListingClientProvider({
  associationSpecs,
  calendarProps,
  children,
  emptyStateFilter,
  fetcher,
  folderProps,
  hiddenFilter: hiddenFilterProp,
  initialFilter,
  inlineEditProps,
  quickFilterProps,
  searchInputProps
}) {
  const {
    deletedObjects,
    filters,
    hasPropertyFilter,
    hiddenFilter,
    isFilterFromCustomView,
    onSetDeletedObjects,
    onSetFilters
  } = useCrmObjectTypeListingFilterState({
    calendarProps,
    hiddenFilter: hiddenFilterProp,
    initialFilter
  });
  const [expandableObjectIds, setExpandableObjectIds] = useState([]);
  const value = useMemo(() => ({
    associationSpecs,
    calendarProps,
    deletedObjects,
    emptyStateFilter,
    expandableObjectIds,
    fetcher,
    filters,
    folderProps,
    hasPropertyFilter,
    hiddenFilter,
    initialFilter,
    inlineEditProps,
    isFilterFromCustomView,
    onSetDeletedObjects,
    onSetExpandableObjectIds: setExpandableObjectIds,
    onSetFilters,
    quickFilterProps,
    searchInputProps
  }), [associationSpecs, calendarProps, deletedObjects, emptyStateFilter, expandableObjectIds, fetcher, filters, folderProps, hasPropertyFilter, hiddenFilter, initialFilter, inlineEditProps, isFilterFromCustomView, onSetDeletedObjects, onSetFilters, quickFilterProps, searchInputProps]);
  return /*#__PURE__*/_jsx(CrmObjectTypeListingContext.Provider, {
    value: value,
    children: children
  });
}
export function useCrmObjectType() {
  const context = useContext(CrmObjectTypeListingContext);
  if (context === undefined) {
    throw new Error('useCrmObjectType must be used within a CrmObjectTypeListingClientProvider');
  }
  return context;
}